import React from 'react'
import logo from '../Image/icon.png'
import { useGlobalContext } from './Context';

function Header() {
    const {logout}=useGlobalContext()

    const handleLogOut=()=>{
      logout()
    }

    return (
        <div className='container-fluid sticky-top '>
            <div className='row' style={{backgroundColor:"rgb(55 99 97)"}}>
                <header className="navbar navbar-dark sticky-top flex-md-nowrap p-0 shadow sticky-top col-md-12">
                    <div>
                        {/* <a href="/admin-dashboard"> */}
                        <img src={logo} alt="this is logo" style={{ width: '300px', height: '80px' }} />
                        {/* </a> */}
                    </div>
                    <button
                        onClick={handleLogOut}
                        type="button" className="button-2 "><span>Log Out</span></button>
                </header>
            </div>
        </div>
    )
}

export default Header